import React, {useEffect, useState} from "react";
import {buildArbitratorOptionList} from "../utils/arbitratorUtils";
import {MenuItem} from "@mui/material";
import {Tooltip} from "@material-ui/core";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Select from "./common/Select";


export const ArbitratorConflictDropDown = ({name, onChange,value,label,arbitrators,pairing,schedule}) => {
    const [options, setOptions] = useState([])

    const recalculateOptions = () => {
        setOptions( buildArbitratorOptionList(pairing.claimant,pairing.respondent,arbitrators,pairing.pairingTime,schedule,pairing.id))
    }
    useEffect(() => {
        recalculateOptions()
    }, [arbitrators]);

    useEffect(() => {
        recalculateOptions()
    },[pairing])


    return (
        <Select name={name}
                onChange={e => onChange(e)}
                value={value}
                label={label}
                customRenderItems={true}
                options={options}
        renderHook={(o,index) => {
           return (<MenuItem key={o.id + index + Math.random()} value={o.id}>
                    <span className={o.isConflicted ? 'arbitrator-conflict' : ''}>
                        {o?.isConflicted &&
                            <Tooltip title={o.reason}>
                                <InfoOutlinedIcon sx={{fontSize: 18}}/>
                            </Tooltip>
                        }
                        {o?.name}
                    </span>
            </MenuItem>
           )}}>
        </Select>
    )
}